/* eslint-disable no-undef */
const axios = require("axios")
import Payment from "./donation-payment"
import { Datepicker } from "vanillajs-datepicker"
import GTMDonationEvents from "./gtm-donation-events"

class Donation {
  constructor() {
    this.form = document.querySelector("[data-donation-form]")

    if (!this.form) {
      if (window.parent !== window) {
        if (
          window.parent.document.body.classList.contains("cms") ||
          !document.body.classList.contains("DonationPage")
        ) {
          return
        }

        document.body.classList.add("d-none")
        const newDiv = window.parent.document.createElement("div")
        const iframe = window.parent.document.querySelector("#donation-payment iframe")
        const payment = window.parent.document.getElementById("donation-payment")
        const segments = window.location.pathname.split("/")
        const lastSegment = segments[segments.length - 1]

        if (document.getElementById("donation-error")) {
          GTMDonationEvents.PaymentFailed("Regular")

          const errorMessage = document.getElementById("donation-error").value
            ? document.getElementById("donation-error").value
            : "There is an error, please try it again later."
          const newContent = window.parent.document.createTextNode(
            "There is an error, will redirect you to the donation page."
          )
          newDiv.appendChild(newContent)
          payment.insertBefore(newDiv, iframe)
          alert(errorMessage)
          window.parent.location.replace(window.parent.location.pathname)
        } else if (lastSegment != "processRecurringDonation") {
          GTMDonationEvents.PaymentFailed("Regular")

          const newContent = window.parent.document.createTextNode(
            "There is an error, will redirect you to the donation page."
          )
          newDiv.appendChild(newContent)
          payment.insertBefore(newDiv, iframe)
          alert("There is an error, please try it again later.")
          window.parent.location.replace(window.parent.location.pathname)
        } else {
          const newContent = window.parent.document.createTextNode("Processing transaction, please don't close window")
          newDiv.appendChild(newContent)
          payment.insertBefore(newDiv, iframe)
          window.parent.location.replace(window.parent.location.pathname.rtrim("/") + "/thankyou")
        }
      }
      return
    }

    this.divisionAutoDetectOn = this.form.classList.contains("hide-location-on-one-off") ? true : false
    this.isRecurring = false
    this.locationSelector = this.form.querySelector(".location-selector")
    this.typeSelectElements = document.querySelectorAll("[data-donation-type-select]")
    this.typeElements = document.querySelectorAll("[data-donation-type]")
    this.amountElements = document.querySelectorAll("[data-donation-amount]")
    this.totalRegularElement = document.querySelector("[data-donation-total-regular]")
    this.totalOneoffElement = document.querySelector("[data-donation-total-oneoff]")
    this.feeRegularElement = document.querySelector("[data-donation-fee-regular]")
    this.feeOneoffElement = document.querySelector("[data-donation-fee-oneoff]")
    this.buttonElements = document.querySelectorAll("[data-donation-btn]")
    this.recurringElements = document.querySelectorAll("[data-donation-recurring]")
    this.stepLabels = document.querySelectorAll("[data-donation-step-label]")
    this.stepViews = document.querySelectorAll("[data-donation-step]")
    this.amountMessageElement = document.querySelector("[data-donation-selected-label]")
    this.amountMessageTemplate = this.amountMessageElement.getAttribute("data-donation-selected-label")
    this.personalInputs = document.querySelectorAll("[data-donation-personal]")
    this.inmemoryElements = document.querySelectorAll("[data-donation-inmemory-select]")
    this.nextButtonElements = document.querySelectorAll("[data-next-btn]")
    this.nextButtonElement = document.querySelector("[data-next-btn]")
    this.locationElement = document.querySelector("[data-donation-location]")
    this.paymentElements = document.querySelectorAll("[data-payment-method]")
    this.internationalDonation = document.querySelector("input[name='InternationalDonations']")
    this.addressField = document.querySelector("input[name='Address1']")
    this.officeSelect = document.getElementById("donation-form-field-OfficeID")
    this.RecurringDonationOfficeSelect = document.getElementById("donation-form-field-RecurringDonationOfficeID")
    this.addressField = document.getElementById("donation-form-field-Address1")
    this.singleFundraiserFormWrapper = document.getElementById("FundraiserDonationWidget-single")
    this.regularFundraiserFormWrapper = document.getElementById("FundraiserDonationWidget-regular")

    // Sets up the date selector
    const dateInput = document.querySelector('input[name="ScheduleStartDate"]')
    if (dateInput) {
      const today = new Date().setHours(0, 0, 0, 0)
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)

      this.datePicker = new Datepicker(dateInput, {
        defaultViewDate: tomorrow,
        showDaysOfWeek: true,
        showOnClick: true,
        showOnFocus: true,
        format: "dd/mm/yyyy",
        minDate: tomorrow, // we don't want today's date because flo2cash will only let you select dates in future
        orientation: "bottom",
        autohide: true,
      })

      this.datePicker.setDate(tomorrow)
    }

    // Update content min-height based on donation form
    this.updateContentHeight()

    this.hideClass = "hide"
    this.feePercentage = 0.03
    this.amount = 0.0
    this.total = 0
    this.step = 1
    this.remainingRetryCount = 5
    this.donationType = 1 // 1=single, 2=recurring
    this.selectedPaymentMethod = "" // this is overridden in onLocationSelect()

    if (this.divisionAutoDetectOn) {
      // put location selector to hidden
      this.locationSelector.classList.add(this.hideClass)
    }

    // Bind event to step buttons
    this.buttonElements.forEach(this.processStep.bind(this))
    // Bind event to toggle amount types
    this.typeSelectElements.forEach(this.setupTypeSelect.bind(this))
    // Bind event to select amount
    this.amountElements.forEach(this.setupAmountSelect.bind(this))
    // Event to ensure only number allowed in total

    if (this.totalOneoffElement) {
      this.totalOneoffElement.addEventListener("input", this.onTotalTyping.bind(this))

      // Event on amount blur to format it
      this.totalOneoffElement.addEventListener(
        "blur",
        () => (this.totalOneoffElement.value = this.formatNumber(this.totalOneoffElement.value))
      )
    }

    if (this.totalRegularElement) {
      this.totalRegularElement.addEventListener("input", this.onTotalTyping.bind(this))
      this.totalRegularElement.addEventListener(
        "blur",
        () => (this.totalRegularElement.value = this.formatNumber(this.totalRegularElement.value))
      )
    }

    // Event on International donation checked
    if (this.internationalDonation) {
      this.internationalDonation.addEventListener("change", this.onInternationalDonationChange.bind(this))
    }

    // Event on fee selection
    if (this.feeOneoffElement) {
      this.feeOneoffElement.addEventListener("change", this.onFeeSelect.bind(this))
    }
    if (this.feeRegularElement) {
      this.feeRegularElement.addEventListener("change", this.onFeeSelect.bind(this))
    }
    // Click event for steps
    this.stepLabels.forEach(element => {
      element.addEventListener("click", () => this.onStepClick(element))
    })
    // Bind event to toggle amount types
    this.inmemoryElements.forEach(this.setupInMemorySelect.bind(this))

    this.nextButtonElements.forEach(this.setupNextButton.bind(this))

    window.addEventListener("load", () => {
      let regularDonation = document.querySelector("#donation-form-regularly")
      if (regularDonation) {
        regularDonation.removeAttribute("disabled")
      }
    })

    /**
     * Settings for Flo2Cash API
     */
    this.flo2CashApiDomain = "https://sandbox.flo2cash.com"
    this.isLive = false
    if (this.form.dataset["isLive"]) {
      this.isLive = true
      this.flo2CashApiDomain = "https://secure.flo2cash.com"
    }
    this.flo2CashSubmitBtn = document.getElementById("flo2cash-submit-btn")
    this.flo2CashForm = document.getElementById("flo2cash-payment-form")
    this.flo2CashFieldset = document.getElementById("flo2cash-payment-fieldset")
    this.pageLink = this.form.dataset.link
    this.flo2CashPaymentData = {}

    if (this.singleFundraiserFormWrapper) {
      this.addSingleDonationFundraiser()
    }

    if (this.RecurringDonationOfficeSelect) {
      //hide and show the regular fundraiser donation form with choiceJS
      this.RecurringDonationOfficeSelect.addEventListener("showDropdown", function() {
        //hide all fundraiser elements on dropdown open
        document.querySelectorAll("[data-payment-method]").forEach(element => {
          if (element.getAttribute("data-payment-method") === "fundraiser") {
            element.classList.add("hide")
          }
        })
      })
    }
  }

  /**
   * Make step label clickable or show pointer
   *
   * @param step
   */
  makeClickable(step) {
    this.stepLabels.forEach(element => {
      if (element.getAttribute("data-donation-step-label") === step) {
        element.classList.add("clickable")
      }
    })
  }

  /**
   * On a fee checkbox select/unselect
   */
  onFeeSelect() {
    // Current value in amount
    let value = 0
    if (this.donationType == 1) {
      value = this.totalOneoffElement.value
      // If fee checkbox unselected then ensure amount reduced by fee cost
      // setTotal will include the fee if the checkbox is selected
      if (this.feeOneoffElement && !this.feeOneoffElement.checked) {
        value -= this.amount * this.feePercentage
      }
    } else {
      value = this.totalRegularElement.value
      if (this.feeRegularElement && !this.feeRegularElement.checked) {
        value -= this.amount * this.feePercentage
      }
    }

    // On fee selection update the total donation amount
    this.setTotal(value)
  }

  /**
   * Show or hide payment forms depending on selected office
   * Decide on which payment type to use: vega, etc
   */
  onLocationSelect() {
    // paymentElements is array of [data-payment-method] data attribute (divs)
    this.paymentElements.forEach(paymentElement => {
      // e.g. data-payment-method="vega", data-payment-method="flo2Cash", etc
      const paymentMethodElement = paymentElement.getAttribute("data-payment-method")

      // e.g. data-payment-officeid="2", data-payment-officeid="3", etc
      const officeIdElement = paymentElement.getAttribute("data-payment-officeid")

      // Value of location dropdown e.g. 2 for Auckland
      this.selectedOfficeId = document.querySelector("[data-donation-location]").value

      // Get payment method based on selectedOfficeId (value of dropdown)
      // e.g. vega (in that order of priority)
      // ONLY used for recurring payments!
      this.selectedPaymentMethod = this.getPaymentMethod()

      if (this.selectedOfficeId && paymentMethodElement === this.selectedPaymentMethod) {
        if (this.selectedPaymentMethod === "fundraiser" && officeIdElement === this.selectedOfficeId) {
          if (this.singleFundraiserFormWrapper) {
            this.resetSingleDonationFundraiser()
          }

          this.addRegularDonationFundraiser(paymentElement)
        } else if (this.selectedPaymentMethod === "flo2Cash" && officeIdElement === this.selectedOfficeId) {
          const merchantId = document.getElementById(`flo2Cash-regular-${this.selectedOfficeId}`).dataset.merchantId

          if (merchantId) {
            document.querySelector("[data-payment-method='flo2Cash-form']").classList.remove(this.hideClass)
          } else {
            console.log("No merchant ID found for Flo2Cash")
          }

          this.updateContentHeight()
        } else if (this.selectedPaymentMethod === "vega" && officeIdElement === this.selectedOfficeId) {
          /**
           * Vega payment form
           */
          paymentElement.classList.remove(this.hideClass)

          const iframe = paymentElement.querySelector("iframe")

          if (iframe && iframe.dataset.src && !iframe.getAttribute("src")) {
            iframe.addEventListener("load", () => {
              iframe.contentWindow.postMessage(window.location.href, "https://connect.vega.works")
            })

            iframe.setAttribute("src", iframe.dataset.src)
          }
        } else {
          paymentElement.classList.add(this.hideClass)
        }
      } else if (this.selectedPaymentMethod !== "flo2Cash") {
        paymentElement.classList.add(this.hideClass)
      }
    })
  }

  /**
   * Event on amount keypress while entering custom amount
   *
   * @param e
   */
  onTotalTyping(e) {
    // Only allow numbers and .
    if (e.which !== 0 && e.which !== 46 && (e.which < 48 || e.which > 57)) {
      e.preventDefault()
    }

    // On entering custom amount reset the fee selection and set new amount
    this.amountElements.forEach(element => (element.checked = false))
    if (this.donationType == 1) {
      if (this.feeOneoffElement) {
        this.feeOneoffElement.checked = false
      }
      if (this.feeRegularElement) {
        this.feeRegularElement.checked = false
      }
      this.amount = parseFloat(this.totalOneoffElement.value)
    } else {
      if (this.feeRegularElement) {
        this.feeRegularElement.checked = false
      }
      if (this.feeOneoffElement) {
        this.feeOneoffElement.checked = false
      }
      this.amount = parseFloat(this.totalRegularElement.value)
    }
  }

  /**
   * Event on InternationalDonation checkbox change
   *
   * @param e
   */
  onInternationalDonationChange() {
    this.addressField.parentElement.classList.toggle(this.hideClass)
    this.locationSelector.classList.toggle(this.hideClass)
  }

  /**
   * Setup event on step button click and process the current step
   *
   * @param button
   */
  processStep(button) {
    button.addEventListener("click", () => {
      const step = String(button.getAttribute("data-donation-btn"))

      // Process step 1
      if (step === "1") {
        return this.processStep1()
      }

      // Process step 2
      if (step === "2") {
        return this.processStep2()
      }
    })
  }

  /**
   * Process step 1
   *
   * @returns {*}
   */
  processStep1() {
    // trigger browser validation
    if (!this.form.checkValidity()) {
      return this.form.reportValidity()
    }

    let amount = 0
    // Update amount message for next step
    if (this.donationType == 1) {
      amount = this.formatNumber(this.totalOneoffElement.value)
    } else {
      amount = this.formatNumber(this.totalRegularElement.value)
    }
    this.amountMessageElement.innerHTML = this.amountMessageTemplate.replace("[amount]", `$${amount}`)

    // Remove disabled attribute for next step fields
    this.personalInputs.forEach(input => input.removeAttribute("disabled"))

    // Populate form from locale storage if any
    const formData = new FormData(this.form)

    for (const key of formData.keys()) {
      const storageValue = window.localStorage.getItem(`csnz_${key}`)
      if (storageValue && key !== "Amount") {
        this.form.elements[key].value = storageValue
        window.localStorage.removeItem(`csnz_${key}`)
      }
    }

    // Move to next step
    this.makeClickable("1")
    this.moveToStep("2")
  }

  /**
   * Donation step 3. (Single donation only)
   */
  sendTransactionRequest(data) {
    axios
      .post(this.form.getAttribute("action"), data, {
        headers: {
          "content-type": "application/json; charset=UTF-8",
        },
      })
      .then(response => {
        if (response.data.hasError) {
          throw new Error(response.data.errorMessage)
        }

        const { transactionReference, paymentUrl, amount, Office } = response.data
        const payment = new Payment()

        payment
          .startTransaction(transactionReference, paymentUrl, amount, Office)
          .then(successUrl => {
            // redirect to thank you page
            location.href = successUrl
          })
          .catch(() => {
            // rerun the transaction when it fails
            if (this.remainingRetryCount--) {
              this.showLoader()
              this.sendTransactionRequest(data)
            }
          })
      })
      .catch(error => {
        if (error.request && error.request.response) {
          this.setTransactionError(error.request.response)
        } else {
          console.log(error)
          this.setTransactionError("Unable to start a transaction. Please refresh page and try again!")
        }
      })
      .finally(() => {
        this.hideLoader()
      })
  }

  /**
   * Process step 2
   *
   * @returns {*}
   */
  processStep2() {
    // Check if user has clicked on a valid address on the address finder
    this.checkAddressValidity()

    // trigger browser validation
    if (!this.form.checkValidity()) {
      return this.form.reportValidity()
    }

    // Move to next step
    this.makeClickable("2")
    this.moveToStep("3")

    // Get data from the form
    let data = {}
    const formData = new FormData(this.form)

    for (const key of formData.keys()) {
      data[key] = formData.get(key)
      // Do not save the ScheduleStartDate into local storage, causes issues with date picker!
      if (key !== "Amount" && key !== "Type" && key !== "RecurringOnDate" && key !== "ScheduleStartDate") {
        window.localStorage.setItem(`csnz_${key}`, formData.get(key))
      }
    }

    // Send request to save the donation details
    this.setTransactionError("")

    // Single (1) or recurring (2) payment
    if (this.donationType == 1) {
      // Hide the recurring paymentform
      this.flo2CashFieldset.classList.add("d-none")
      document.querySelector("#donation-payment").classList.remove("d-none")

      this.showLoader()
      this.sendTransactionRequest(data)
    } else if (this.donationType == 2 && this.selectedPaymentMethod == "flo2Cash") {
      this.loadRecurringPayment(data)
    }
  }

  /**
   * For recurring payment only
   */
  loadRecurringPayment(data) {
    if (data["RecurringDonationOfficeID"]) {
      data["OfficeID"] = data["RecurringDonationOfficeID"]
    }

    axios
      .post(this.form.getAttribute("action"), data, {
        headers: {
          "content-type": "application/json; charset=UTF-8",
        },
      })
      .then(response => {
        if (response.data.hasError) {
          throw new Error(response.data.errorMessage)
        }

        this.loadFlo2CashPayment(response.data)
      })
      .catch(error => {
        if (error.response && error.response.data && error.response.data.hasError) {
          this.setTransactionError(error.response.data.errorMessage)
        } else {
          this.setTransactionError("Unable to start a transaction. Please refresh page and try again!")
        }
      })
      .finally(() => {
        this.hideLoader()
      })
  }

  /**
   * Load the Flo2Cash API
   * @param {Object} data
   */
  loadFlo2CashPayment(data) {
    // save the payment info
    this.flo2CashPaymentData = data

    // Show the recurring payment form
    this.flo2CashFieldset.classList.remove("d-none")

    const iFrameApiKey = data.key
    const environment = this.isLive ? "prod" : "sandbox"
    const donationPaymentForm = document.getElementById("donation-payment")
    const defaultStyle = `
    width: 85%;
    margin: 5px;
    min-height: 1.1rem;
    padding: 10px 15px;
    font-size: 1rem;
    line-height: 1;
    background-color: white;
    border: 2px solid transparent;
    border-radius: 6px;
    box-shadow: 0 0 4px 0 rgba(50, 50, 50, 0.04), 0 2px 8px 0 rgba(50, 50, 50, 0.08);
    `
    const monthAndYearStyle = `
      ${defaultStyle}
      width: 70%;
    `
    const errorStyle = `
      ${defaultStyle}
      border-color: #bf2e24;
    `
    const errorMonthAndYearStyle = `
      ${monthAndYearStyle}
      border-color: #bf2e24;
    `

    // Setup the credit card form, each field is its own iFrame
    Flo2Cash.initialise(
      iFrameApiKey,

      {
        id: "flo2cash-payment-form",
        tokenField: "f2c-token", // Hidden input field for credit card token
        mode: environment,
        inputFields: {
          number: {
            id: "f2c-card-number",
            style: defaultStyle,
            placeholder: "Card Number",
          },
          cvv: {
            id: "f2c-cvv",
            style: defaultStyle,
            placeholder: "Enter CSC/CVV",
          },
          expiryDate: {
            id: "f2c-expiry-date",
            "style-month": monthAndYearStyle,
            "style-year": monthAndYearStyle,
            "placeholder-month": "MM",
            "placeholder-year": "YY",
          },
          nameOnCard: {
            id: "f2c-name-on-card",
            style: defaultStyle,
            placeholder: "Cardholder Name",
          },
        },
      }
    )

    //show the form once it has been initialised
    donationPaymentForm.classList.remove("d-none")

    // Setup the button click event
    this.flo2CashSubmitBtn.addEventListener("click", () => {
      // Tokenise the credit card and load it in the hidden field
      Flo2Cash.getToken()
    })

    Flo2Cash.register("onFieldChange", function(evt) {
      const field = evt.id
      const eventType = evt.type
      const valid = evt.data.valid

      if (eventType === "blur") {
        if (valid) {
          if (field === "number" || field === "cvv" || field === "name") {
            Flo2Cash.setStyle(field, defaultStyle)
          } else {
            Flo2Cash.setStyle(field, monthAndYearStyle)
          }
        } else {
          if (field === "number" || field === "cvv" || field === "name") {
            Flo2Cash.setStyle(field, errorStyle)
          } else {
            Flo2Cash.setStyle(field, errorMonthAndYearStyle)
          }
        }
      } else if (eventType === "cardType") {
        if (evt.data.cardType.value === "visa") {
          document.querySelector("[data-donation-visa-logo]").classList.remove("d-none")
        } else if (evt.data.cardType.value === "mastercard") {
          document.querySelector("[data-donation-mastercard-logo]").classList.remove("d-none")
        }
      }
    })

    // Register a Flo2Cash callback for tokenisation of card
    Flo2Cash.register("onTokenisation", () => {
      // Read the credit card token and append it to the payload for backend
      const creditCardToken = document.getElementById("f2c-token").value
      this.flo2CashPaymentData.token = creditCardToken

      //reset all error styling and show loader
      this.setTransactionError("")
      this.showLoader("Processing payment...")
      donationPaymentForm.classList.add("d-none")

      // Send data back to backend to make recurring payment API request
      this.afterFlo2CashFormSubmit(this.flo2CashPaymentData)
    })

    // Register a Flo2Cash callback for errors
    Flo2Cash.register("onError", evt => {
      let errors = ""

      //reset all error styling
      Flo2Cash.setStyle("number", defaultStyle)
      Flo2Cash.setStyle("cvv", defaultStyle)
      Flo2Cash.setStyle("expiry-month", monthAndYearStyle)
      Flo2Cash.setStyle("expiry-year", monthAndYearStyle)
      Flo2Cash.setStyle("name", defaultStyle)
      this.setTransactionError("")

      // Read all errors
      for (let i = 0; i < evt.length; i++) {
        errors += evt[i].message + "<br>"

        // Set error styling on the appropriate field
        if (evt[i].id == "number") {
          Flo2Cash.setStyle("number", errorStyle)
        } else if (evt[i].id == "cvv") {
          Flo2Cash.setStyle("cvv", errorStyle)
        } else if (evt[i].id == "expiry-month") {
          Flo2Cash.setStyle("expiry-month", errorMonthAndYearStyle)
        } else if (evt[i].id == "expiry-year") {
          Flo2Cash.setStyle("expiry-year", errorMonthAndYearStyle)
        } else if (evt[i].id == "name") {
          Flo2Cash.setStyle("name", errorStyle)
        }
      }
      this.setTransactionError(errors)
    })
  }

  /**
   * Send data to backend to make recurring payment plan on Flo2Cash
   * @param {Object} data
   */
  afterFlo2CashFormSubmit(data) {
    // Make an API request to create a new recurring payment plan

    let currentUrl = this.pageLink
    currentUrl.replace("?stage=Stage", "")
    if (currentUrl.substr(-1) === "/") {
      currentUrl = currentUrl.substr(0, currentUrl.length - 1)
    }
    const endpoint = `${currentUrl}/processRecurringPayment`
    const dataJson = JSON.stringify(data)

    axios
      .post(endpoint, dataJson, {
        headers: {
          "content-type": "application/json; charset=UTF-8",
        },
      })
      .then(response => {
        GTMDonationEvents.ProceedToPayment(data.amount, data.Office)

        if (response.data.hasError) {
          throw new Error(response.data.errorMessage)
        }

        this.showLoader("Transaction has been processed successfully.")
        // redirect to success url
        window.location = response.data.successUrl
      })
      .catch(error => {
        this.hideLoader()
        this.setTransactionError(error)
        document.querySelector("#donation-payment").classList.remove("d-none")
      })
  }

  /**
   * Hide loader from payment view
   */
  hideLoader() {
    document.querySelector("[data-donation-loader]").classList.add("d-none")
  }

  /**
   * Show loader from payment view
   */
  showLoader(spinnerText = "Preparing transaction") {
    const loaderEl = document.querySelector("[data-donation-loader]")
    const spinnerTextEl = document.querySelector("[data-donation-loader-text]")
    spinnerTextEl.innerHTML = spinnerText + "<span>.</span><span>.</span><span>.</span>"
    loaderEl.classList.remove("d-none")
  }

  /**
   * Display error from payment view
   */
  setTransactionError(message) {
    const wrapperElement = document.querySelector("[data-donation-error]")
    const messageElement = document.querySelector("[js-payment-error-message]")

    messageElement.innerHTML = message
    wrapperElement.classList.remove("d-none")

    if (!message) {
      wrapperElement.classList.add("d-none")
    } else {
      GTMDonationEvents.PaymentFailed()
    }
  }

  /**
   * Event on mouse click
   *
   * @param element
   */
  onStepClick(element) {
    // If current step is 2 and we want to view step one
    if (this.step === "2" && element.getAttribute("data-donation-step-label") === "1") {
      this.moveToStep("1")
    }
    // If current step is 1 and we want step 2
    if (this.step === "1" && element.getAttribute("data-donation-step-label") === "2") {
      this.processStep1()
    }
  }

  /**
   * Change the view to a step
   *
   * @param step
   */
  moveToStep(step) {
    this.step = step
    const activeClass = "active" // show or hide via _donation-form.scss

    if (step === "1") {
      // Remove disabled attribute for next step fields
      this.personalInputs.forEach(input => input.setAttribute("disabled", "disabled"))
    }

    if (step === "2") {
      // Add required attribute to OffceID select list.
      if (document.querySelector("[data-donation-office]")) {
        document.querySelector("[data-donation-office]").removeAttribute("required")
        if (!this.divisionAutoDetectOn && this.donationType == 1) {
          document.querySelector("[data-donation-office]").setAttribute("required", "required")
        }
      }
    }

    // Hide all labels and make current active
    this.stepLabels.forEach(element => {
      if (element.getAttribute("data-donation-step-label") === step) {
        element.classList.add(activeClass)
      } else {
        element.classList.remove(activeClass)
      }
    })

    // Hide all views and make current visible
    this.stepViews.forEach(element => {
      if (element.getAttribute("data-donation-step") === step) {
        element.classList.add(activeClass)
      } else {
        element.classList.remove(activeClass)
      }
    })

    // Scroll to top of the form
    window.scrollTo({
      top: this.form.getBoundingClientRect().top,
      left: 0,
      behavior: "smooth",
    })
    this.makeClickable(step)
  }

  addSingleDonationFundraiser() {
    const fundraiserKey = this.singleFundraiserFormWrapper.getAttribute("data-fundraiser-key")
    const script = document.createElement("script")

    this.singleFundraiserFormWrapper.classList.remove(this.hideClass)

    if (document.querySelector(`script[src*="${fundraiserKey}"]`)) {
      console.log("already loaded")
      return
    }

    script.src = `https://app.fundraiserone.net/Widgets/DonationWidget/js?wv=1&key=${fundraiserKey}`
    script.type = "application/javascript"
    script.defer = true
    document.body.appendChild(script)

    script.addEventListener("load", function() {
      // eslint-disable-next-line no-undef
      $.isFunction($("#FundraiserDonationWidget-single").Donation) && $("#FundraiserDonationWidget-single").Donation()
    })
  }

  resetSingleDonationFundraiser() {
    const fundraiserKey = this.singleFundraiserFormWrapper.getAttribute("data-fundraiser-key")
    const script = document.querySelector(`script[src*="${fundraiserKey}"]`)
    this.singleFundraiserFormWrapper.classList.add(this.hideClass)
    if (script) {
      script.remove()
    }
  }

  addRegularDonationFundraiser(element) {
    const fundraiserKey = element.getAttribute("data-fundraiser-key")
    const script = document.createElement("script")
    const elementID = element.getAttribute("id")

    element.classList.remove(this.hideClass)

    //make sure remove all other scripts from fundraiser one but not the one we want to load
    document.querySelectorAll(`script[src*="fundraiserone.net"]`).forEach(script => {
      if (script.src.indexOf(fundraiserKey) === -1) {
        script.remove()
      }
    })

    if (document.querySelector(`script[src*="${fundraiserKey}"]`)) {
      console.log("already loaded")
      return
    }

    script.src = `https://app.fundraiserone.net/Widgets/DonationWidget/js?wv=1&key=${fundraiserKey}`
    script.type = "application/javascript"
    script.defer = true
    document.body.appendChild(script)

    /* eslint-disable */
    script.addEventListener("load", function() {
      if ($.isFunction($(`#${elementID}`).Donation)) {
        $(`#${elementID}`).Donation()
      }
    })
    /* eslint-enable */
  }

  /**
   * Setup event for donation type selection
   *
   * @param element
   */
  setupTypeSelect(element) {
    element.addEventListener("change", () => {
      if (element.checked) {
        this.donationType = element.value
        let locationElement = document.querySelector("[data-donation-location]")

        const step2 = document.querySelector('.donation-form__step-form[data-donation-step="2"]')

        if (this.donationType == 1) {
          if (this.totalOneoffElement) {
            this.totalOneoffElement.removeAttribute("disabled")
          }
          this.totalRegularElement.setAttribute("disabled", true)
          locationElement.removeAttribute("required")

          if (step2) {
            step2.querySelector(".location-selector").classList.remove("d-none")
          }

          if (this.singleFundraiserFormWrapper) {
            this.addSingleDonationFundraiser()
          }
        } else {
          if (this.totalOneoffElement) {
            this.totalOneoffElement.setAttribute("disabled", true)
          }
          this.totalRegularElement.removeAttribute("disabled")
          locationElement.setAttribute("required", true)

          if (step2) {
            step2.querySelector(".location-selector").classList.add("d-none")
          }
        }
      }

      if (this.divisionAutoDetectOn) {
        if (element.id == "donation-form-monthly") {
          this.isRecurring = true
          this.locationSelector.classList.remove(this.hideClass)
        } else if (element.id == "donation-form-today") {
          this.isRecurring = false
          this.locationSelector.classList.add(this.hideClass)
        }
      }

      this.typeElements.forEach(typeElement => {
        // Reset amount if donation type changed
        this.setTotal("")

        // Show/Hide fields based on type selection
        const typeValue = typeElement.getAttribute("data-donation-type")
        if (String(typeValue) === String(element.value)) {
          typeElement.classList.remove(this.hideClass)
        } else {
          typeElement.classList.add(this.hideClass)
        }

        if (typeElement.getAttribute("data-trigger-next-btn") === "1") {
          this.nextButtonElement.click()
        }
      })
    })
  }

  /**
   * Setup event on next button click
   *
   * @param button
   */
  setupNextButton(button) {
    button.addEventListener("click", () => {
      if (!document.querySelector("[data-donation-location]").checkValidity()) {
        return document.querySelector("[data-donation-location]").reportValidity()
      }
      if (this.locationElement) {
        this.locationElement.addEventListener("change", this.onLocationSelect.bind(this))
      }

      this.onLocationSelect()
      button.classList.add(this.hideClass)
    })
  }

  /**
   * Decide on what payment method to use (recurring payments only)
   */
  getPaymentMethod() {
    // The [data-payment-method] is inserted into the template (FormStep1.ss) from DonationPage.php
    const vegaOffices = document.querySelectorAll("[data-payment-method='vega']")
    const fundraiserOffices = document.querySelectorAll("[data-payment-method='fundraiser']")
    const flo2CashOffices = document.querySelectorAll("[data-payment-method='flo2Cash']")

    for (let i = 0; i < fundraiserOffices.length; i++) {
      const officeElement = fundraiserOffices[i]

      // selectedOfficeId is a data attribute from [data-donation-location]
      // Selected office from dropdown
      if (officeElement.getAttribute("data-payment-officeid") === this.selectedOfficeId) {
        return "fundraiser"
      }
    }

    for (let i = 0; i < vegaOffices.length; i++) {
      const officeElement = vegaOffices[i]

      // selectedOfficeId is a data attribute from [data-donation-location]
      // Selected office from dropdown
      if (officeElement.getAttribute("data-payment-officeid") === this.selectedOfficeId) {
        return "vega"
      }
    }

    for (let i = 0; i < flo2CashOffices.length; i++) {
      const officeElement = flo2CashOffices[i]

      // selectedOfficeId is a data attribute from [data-donation-location]
      // Selected office from dropdown
      if (officeElement.getAttribute("data-payment-officeid") === this.selectedOfficeId) {
        return "flo2Cash"
      }
    }

    return false
  }

  /**
   * Setup event for amount selection
   *
   * @param element
   */
  setupAmountSelect(element) {
    element.addEventListener("click", e => {
      // Set total based on amount selected
      this.amount = Number(e.target.value)
      this.setTotal(e.target.value)
      // Scroll to the bottom of the form
      this.form.scrollIntoView({ behavior: "smooth", block: "end" })
    })
  }

  /**
   * Set donation total
   *
   * @param value
   */
  setTotal(value) {
    // Ensure amount is formatted
    let total = parseFloat(value)

    // Add fee percentage
    if (this.donationType == 1) {
      if (this.feeOneoffElement && this.feeOneoffElement.checked) {
        total += parseFloat(this.amount) * this.feePercentage
      }
    } else {
      if (this.feeRegularElement && this.feeRegularElement.checked) {
        total += parseFloat(this.amount) * this.feePercentage
      }
    }

    // Prevent display of zero
    if (parseInt(total, 10) === 0) {
      total = ""
    }

    // Update total in amount field
    if (this.donationType == 1) {
      if (this.totalOneoffElement) {
        this.totalOneoffElement.value = this.formatNumber(total)
      }
    } else {
      this.totalRegularElement.value = this.formatNumber(total)
    }
    // this.totalElement.value = this.formatNumber(total)
    // Store total + fee
    this.total = total
  }

  /**
   * Get selected type element
   *
   * @returns {*}
   */
  getSelectedType() {
    return [...this.typeSelectElements].find(element => element.checked)
  }

  /**
   * Get selected recurring element
   *
   * @param typeValue
   * @returns {*}
   */
  getSelectedRecurringType(typeValue) {
    return [...this.recurringElements].find(
      element => element.getAttribute("data-donation-recurring") === String(typeValue) && element.checked
    )
  }

  /**
   * Format a value to number with 2 decimal points
   *
   * @param value
   * @returns {number}
   */
  formatNumber(value) {
    return Number(String(value).replace(/[^\d.-]/g, ""))
      .toFixed(2)
      .replace(".00", "")
  }

  /**
   * Setup event for donation in memory selection
   *
   * @param element
   */
  setupInMemorySelect(element) {
    // Get container holding the in memory fields
    const fieldsContainer = document.querySelector("[data-donation-inmemory-fields]")
    // Show/Hide field based on user selection
    element.addEventListener("change", e => {
      fieldsContainer.classList.add(this.hideClass)
      if (e.target.value === "1") {
        fieldsContainer.classList.remove(this.hideClass)
      }
    })
  }

  updateContentHeight() {
    // Wait for page to load!
    setTimeout(() => {
      let contentHeight = this.form.getBoundingClientRect().height
      const contentImage = document.querySelector("[data-donation-foot-img]")
      // 300 is the image height - reduce content height by the height of the image in the content
      if (contentImage) {
        contentHeight -= 300
      }
      // 781 is the default content height - only set new height if donation form longer than the content
      if (contentHeight > 781) {
        document.querySelector(".donation-content").setAttribute("style", `--form-height:${contentHeight}px`)
      }
    }, 500)
  }

  /**
   * Validate the address finder field - don't process form if not selected from dropdown
   * Check the postcode that is returned by the address finder widget
   */
  checkAddressValidity() {
    if (this.internationalDonation?.checked) {
      this.isRecurring = document.querySelector(`[name="Type"]:checked`)?.value == "2"

      if (!this.isRecurring && !this.officeSelect.value) {
        this.officeSelect.setCustomValidity("Please select the location of your donation")
      } else if (this.isRecurring && !this.RecurringDonationOfficeSelect.value) {
        this.RecurringDonationOfficeSelect.setCustomValidity("Please select the location of your donation")
      } else {
        this.clearAddressFieldsForInternationalDonation()
        this.officeSelect.setCustomValidity("")
        this.addressField.required = false
      }
    } else {
      if (document.querySelector(`[name="Postcode"]`) !== undefined) {
        const postcode = document.querySelector(`[name="Postcode"]`).value
        let address1Field = null
        if (!postcode && document.querySelector(`[name="Address1"]`) !== undefined) {
          address1Field = document.querySelector(`[name="Address1"]`)
          address1Field.setCustomValidity(`Please select an address from the dropdown box`)
          return address1Field.reportValidity()
        } else {
          address1Field = document.querySelector(`[name="Address1"]`)
          address1Field.setCustomValidity("")
        }
      }
    }
  }

  clearAddressFieldsForInternationalDonation() {
    document.querySelector(`[name="Address[Address1]"]`).value = null
    document.querySelector(`[name="Address[Address2]"]`).value = null
    document.querySelector(`[name="Address[Suburb]"]`).value = null
    document.querySelector(`[name="Address[City]"]`).value = null
    document.querySelector(`[name="Address[Postcode]"]`).value = null
    document.querySelector(`[name="Address[Country]"]`).value = null
    document.querySelector(`[name="Address[dpid]"]`).value = null
    document.querySelector(`[name="StreetNumber`).value = null
    document.querySelector(`[name="StreetName`).value = null
    document.querySelector(`[name="Suburb`).value = null
    document.querySelector(`[name="City`).value = null
    document.querySelector(`[name="Region`).value = null
    document.querySelector(`[name="Postcode`).value = null
  }
}

export default Donation
